export default __webpack_public_path__ + "static/media/agency-illustration.9b50203e.webp";